import { useAppLayout } from '@/components/AppLayout/AppLayoutProvider'
import {
  createEventAbExperiment,
  createEventClick,
  createEventEngagement,
  createEventImpression,
  TrackAbExperimentData,
  TrackClickData,
  TrackEngagementData,
  TrackImpressionData,
} from '@/utils/tracking.utils'

export default function useTracking() {
  const { root } = useAppLayout()

  const trackImpression = (data: TrackImpressionData) => {
    root.current?.dispatchEvent(createEventImpression(data))
  }

  const trackClick = (data: TrackClickData) => {
    root.current?.dispatchEvent(createEventClick(data))
  }

  const trackEngagement = (data: TrackEngagementData) => {
    root.current?.dispatchEvent(createEventEngagement(data))
  }

  const trackAbExperiment = (data: TrackAbExperimentData) => {
    root.current?.dispatchEvent(createEventAbExperiment(data))
  }

  return {
    trackImpression,
    trackClick,
    trackEngagement,
    trackAbExperiment,
  }
}
